module.exports = __webpack_public_path__ + "static/media/I1_DIFF.547f5e27.png";